import {css} from "@emotion/react";
import React from "react";

const colors: Record<number, string> = {
	0: "#e5e5e5",
	1: "#9B2C2C",
	2: "#D44949",
	3: "#DCA02D",
	4: "#387F95",
	5: "#48AE65",
};

const getColor = (power: number, index: number) => {
	if (power > index) {
		return colors[power];
	}
	return colors[0];
};

const indicatorIndexes = [0, 1, 2, 3, 4];

const cssMt2 = css`
	margin-top: 0.5rem;
`
const cssIndicator = css`
	height: 2px;
	border-radius: 4px;
	width: 20%;
	margin: 0 4px;
`
const cssIndicatorContainer = css`
	flex-direction: row;
	display: flex;
`

function IndicatorsComponent({score}: { score: number }) {
	return <div css={css`${cssMt2} ${cssIndicatorContainer}`}>
		{indicatorIndexes.map((indicatorIndex, index) => (
			<div
				css={cssIndicator}
				key={indicatorIndex}
				style={{backgroundColor: getColor(score + 1, indicatorIndex)}}
			/>
		))}
	</div>
};

export {IndicatorsComponent};
